import { Breadcrumb } from "@hellocarbo/lasagne";
import { use } from "react";
import { data, Outlet, useLoaderData, useLocation } from "react-router";

import { FeaturesContext, PortalContainerContext } from "@/contexts";
import useBreadcrumbs from "@/hooks/useBreadcrumbs";
import { TDynamicCategory } from "@/types";
import { cn } from "@/utils/classes";

import { overlayedClassname } from "./Review";

export async function loader() {
  const categoriesResponse = await fetch(`/api/client/categories`);
  if (categoriesResponse.status !== 200) {
    throw data("Failed to load the categories", {
      status: categoriesResponse.status,
    });
  }
  const { data: categories } = (await categoriesResponse.json()) as {
    data: TDynamicCategory[];
  };

  return {
    categories,
  };
}

const Collect = () => {
  const { categories } = useLoaderData<typeof loader>();
  const { container } = use(PortalContainerContext);
  const { crumbs } = useBreadcrumbs(categories);
  const { featureFlags } = use(FeaturesContext);
  const location = useLocation();

  // All import deposit pages except /new have been migrated to React
  const isMigratedImportDepositPage =
    location.pathname.includes("import_deposits") &&
    !location.pathname.includes("/new");

  const isImportDepositMatching =
    location.pathname.includes("import_deposits") &&
    location.pathname.includes("/matching");

  return (
    <>
      <div /* We need a different Breadcrumb styling depending on the type of page (Rails or React) */
        className={cn(
          (isMigratedImportDepositPage &&
            featureFlags?.[
              "import_deposit_view_react"
            ]) /* Ongoing migration towards React */ ||
            (isImportDepositMatching &&
              featureFlags?.[
                "import_to_verify_interface"
              ]) /* New feature under FF that happens to be in React */
            ? "px-xl mt-sm"
            : overlayedClassname
        )}
      >
        <Breadcrumb portalContainer={container!} crumbs={crumbs} />
      </div>
      <Outlet />
    </>
  );
};

export default Collect;
